import moment from 'moment';
export const
    INITIAL_STATE = { 
        //Complaint type
        complaintType:{
            name: 'Warranty',
            displayName: 'Gwarancja',
            id:1
        },
        //Complaint create date
        createDate: moment(),
        //ERP status name
        erpStatus:'',
        //Is complaint issuing. Used for blocking components from interaction/
        isIssuing : false,
        //Is term of use accepted
        isTermOfUseAccepted: false,
        //Complaint notes
        notes: '',
        //Complaint number
        number:'',
        //Complaint password
        password:'',
    };


// WEBPACK FOOTER //
// ./src/reducers/state/Complaint.js